'use strict';

export function getTranslate(str) {
  let array = str.match(/(-?[\d\.]+)/g);
  return {
    x: parseFloat(array[4]),
    y: parseFloat(array[5]),
  };
}
